import styled from '@emotion/styled'

export const DestinationActions = styled('div')`
  padding-top: 20px;
`

export const DestinationsCountTyphography = styled('p')`
  margin: 0 0 20px 0;
`
